const SchemaSyncHandler = {
  sync() {
    const { idb, cache } = self;
    if (idb) {
      const { openDatabase } = cache;
      openDatabase();
    }
  }
};
export default SchemaSyncHandler;
